import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NextIcon } from 'foundations-assets';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import ChecklistTasks from '../../checklist/ChecklistTasks';
import ChecklistDuration from '../../checklist/task/ChecklistDuration';
import { useTracker } from '../../../hooks/tracking';
import { useTaskData, useTaskGroupProgress, useTaskDataByGroupKey, useNextTaskGroupData } from '../../../hooks/task';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskGroupSidePanel = ({
  groupKey,
  onCloseClick,
  showUpNextTask = true,
  onNextTaskGroupClick
}) => {
  const {
    taskProgress
  } = useTaskData();
  const taskGroupData = useTaskDataByGroupKey(groupKey);
  const {
    taskMap,
    name: goalTitle,
    description
  } = taskGroupData;
  const taskGroupProgress = useTaskGroupProgress(taskGroupData);
  const nextTaskGroupData = useNextTaskGroupData(groupKey);
  const {
    key: nextTaskGroupKey,
    name: nextTaskGroupName
  } = nextTaskGroupData;
  const {
    trackUserInteraction,
    trackSectionView
  } = useTracker();
  const hasTaskData = nextTaskGroupData && nextTaskGroupName && nextTaskGroupKey;
  useEffect(() => {
    trackSectionView('task group side panel', groupKey);
  }, [trackSectionView, groupKey]);
  return /*#__PURE__*/_jsxs(ModalPanel, {
    "data-test-id": "task-group-sidepanel",
    width: 450,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: goalTitle
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "task-group-modal-close-button",
        onClick: () => {
          trackUserInteraction('task group sidebar close button click', groupKey);
          onCloseClick();
        }
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      padding: "0",
      children: [/*#__PURE__*/_jsxs(View, {
        paddingBlock: "600",
        paddingInline: "1000",
        children: [description || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskGroupSidePanel.header"
        }), /*#__PURE__*/_jsx(View, {
          as: "div",
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsx(ChecklistDuration, {
            estimation: taskGroupProgress
          })
        })]
      }), /*#__PURE__*/_jsx(ChecklistTasks, {
        TasksCompletedComponent: null,
        expandFirstUncompletedTask: true,
        groupKey: groupKey,
        showActionedTasks: true,
        taskData: {
          isLoading: false,
          taskMap,
          taskProgress
        }
      })]
    }), showUpNextTask && hasTaskData && /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexWrap: "nowrap",
        gap: "200",
        inlineSize: "100%",
        justifyContent: "center",
        maxBlockSize: "100%",
        overflow: "hidden",
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "task-group-modal-footer-next-link",
          margin: "0",
          onClick: () => {
            trackUserInteraction('task group sidebar next task group click', groupKey);
            onNextTaskGroupClick(nextTaskGroupKey);
          },
          paddingInline: "0",
          truncate: true,
          use: "transparent",
          width: "auto",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.consolidatedUserGuide.taskGroupSidePanel.footer",
            options: {
              nextTaskGroupName
            }
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexShrink: "0",
          children: /*#__PURE__*/_jsx(NextIcon, {
            color: "icon-interactive-default",
            size: "400"
          })
        })]
      })
    })]
  });
};
export default TaskGroupSidePanel;